import services from '@/services/ConfiguracaoRastreabilidadeService';

export function cadastrarParametros(configuracao) {
    const percentualCapacidadeProdutiva =
        configuracao.percentualCapacidadeProdutiva
            ? configuracao.percentualCapacidadeProdutiva
            : 15;
    const exececaoMunicio = excecoesMunicipio => ({
        distanciaRaioKm: excecoesMunicipio.distanciaRaioKm,
        idMunicipio: excecoesMunicipio.idMunicipio,
        percentualCapacidadeProdutiva:
            excecoesMunicipio.percentualCapacidadeProdutiva,
        tipoCadastro: 'MUNICIPIO'
    });
    const params = {
        id: null,
        aplicarEstado: false,
        idFornecedor: configuracao.idFornecedor,
        aplicarTodoEstado: true,
        excecoes: configuracao.excecoes.map(excecao => ({
            aplicarTodoEstado: excecao.aplicarTodoEstado,
            idEstado: excecao.idEstado,
            idMunicipio: null,
            percentualCapacidadeProdutiva:
                excecao.percentualCapacidadeProdutiva,
            distanciaRaioKm: excecao.distanciaRaioKm,
            excecoes: configuracao.excecoes.length
                ? excecao.excecoes.map(exececaoMunicio)
                : [],
            tipoCadastro: 'ESTADO'
        })),
        idEstado: null,
        idMunicipio: null,
        distanciaRaioKm: configuracao.distanciaRaioKm,
        percentualCapacidadeProdutiva,
        tipoCadastro: 'FORNECEDOR'
    };

    return services.cadastrarConfiguracaoRastreabilidade(params);
}

export function editarParametros(configuracao) {
    const percentualCapacidadeProdutiva =
        configuracao.percentualCapacidadeProdutiva
            ? configuracao.percentualCapacidadeProdutiva
            : 15;
    const exececaoMunicio = excecoesMunicipio => ({
        id: excecoesMunicipio.id,
        distanciaRaioKm: excecoesMunicipio.distanciaRaioKm,
        idMunicipio: excecoesMunicipio.idMunicipio,
        percentualCapacidadeProdutiva:
            excecoesMunicipio.percentualCapacidadeProdutiva,
        tipoCadastro: 'MUNICIPIO'
    });
    const params = {
        id: configuracao.id,
        aplicarEstado: false,
        idFornecedor: configuracao.idFornecedor,
        aplicarTodoEstado: true,
        excecoes: configuracao.excecoes.map(excecao => ({
            id: excecao.id,
            aplicarTodoEstado: excecao.aplicarTodoEstado,
            idEstado: excecao.idEstado,
            idMunicipio: null,
            percentualCapacidadeProdutiva:
                excecao.percentualCapacidadeProdutiva,
            distanciaRaioKm: excecao.distanciaRaioKm,
            excecoes: configuracao.excecoes.length
                ? excecao.excecoes.map(exececaoMunicio)
                : [],
            tipoCadastro: 'ESTADO'
        })),
        idEstado: null,
        idMunicipio: null,
        distanciaRaioKm: configuracao.distanciaRaioKm,
        percentualCapacidadeProdutiva,
        tipoCadastro: 'FORNECEDOR'
    };

    return services.editarConfiguracaoRastreabilidade(params);
}

export async function buscarParametros(id) {
    const { data } = await services.findById(id);

    const percentualCapacidadeProdutiva = data.percentualCapacidadeProdutiva
        ? data?.percentualCapacidadeProdutiva
        : 15;
    const exececaoMunicio = excecoesMunicipio => ({
        id: excecoesMunicipio.id,
        distanciaRaioKm: excecoesMunicipio.distanciaRaioKm,
        idMunicipio: excecoesMunicipio.idMunicipio,
        percentualCapacidadeProdutiva:
            excecoesMunicipio.percentualCapacidadeProdutiva
    });

    const params = {
        id: data.id,
        idFornecedor: data?.idFornecedor,
        distanciaRaioKm: data?.distanciaRaioKm,
        percentualCapacidadeProdutiva,

        excecoes: data?.excecoes.map(excecao => ({
            id: excecao?.id,
            naoTemExcecaoMunicipio: !excecao?.excecoes?.length,
            aplicarTodoEstado: excecao.aplicarTodoEstado,
            idEstado: excecao?.idEstado,
            idMunicipio: excecao?.idMunicipio,
            percentualCapacidadeProdutiva:
                excecao.percentualCapacidadeProdutiva,
            distanciaRaioKm: excecao.distanciaRaioKm,

            excecoes: data?.excecoes?.length
                ? excecao.excecoes.map(exececaoMunicio)
                : []
        }))
    };
    return params;
}
